import { useMemo, useState, useEffect } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import Image, { ImageProps } from 'frontastic/lib/image';
import Slider from 'components/commercetools-ui/atoms/slider';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import useTouchDevice from 'helpers/hooks/useTouchDevice';
import { desktop, mediumDesktop, tablet } from 'helpers/utils/screensizes';
import { StaticImageData } from 'next/image';
import WhiteOverlay from 'components/commercetools-ui/atoms/overlay/white-overlay';
import usePreloadImages from 'helpers/hooks/usePreloadImages';
import { NationalBook, NationalSemibold, Tiempos } from 'fonts';
import { useParams } from 'next/navigation';

const SectionWithBannerSlider = (props: any) => {
  const { content } = props;
  console.log('SectionWithBannerSlider', content);
  const data = content;
  const { isTouchDevice } = useTouchDevice();

  const { locale, slug: categorySlug } = useParams();
  const lessHeight = true;

  const [isDesktopSize] = useMediaQuery(mediumDesktop);
  const [isTabletSize] = useMediaQuery(tablet);
  const [nextButtonHovered, setnextButtonHovered] = useState(false);
  const [loading, setLoading] = useState(true);
  const showArrows = useMemo(
    () =>
      !isTouchDevice &&
      !((isDesktopSize && data?.banner_slider?.length <= 4) || (!isDesktopSize && data?.banner_slider?.length <= 2)),
    [isDesktopSize, isTouchDevice, data?.banner_slider?.length],
  );

  usePreloadImages([
    data?.banner_slider?.[0]?.banner_desktop_image?.url,
    data?.banner_slider?.[1]?.banner_desktop_image?.url,
  ]);

  return (
    <>
      {loading && <WhiteOverlay />}
      <div className={`${content.additional_css ?? ''} hero-slider-container relative w-full`}>
        <Slider
          containerClassName={showArrows ? '' : ''}
          slidesPerView={1}
          dots={true}
          arrows={isTabletSize}
          innerArrows
          allowArrowsOnTouchDevice
          allowTouchMove={true}
          prevButtonStyles={{ padding: '20px', left: '0px' }}
          nextButtonStyles={{ padding: '20px', right: '0px' }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {data?.banner_slider?.map(
            (
              slide: {
                ctas: any;
                banner_desktop_image: { url: string | StaticImageData | undefined; title: string | undefined; description: string | undefined };
                banner_heading: string | undefined;
                banner_description: string | undefined;
                call_to_action: { title: string | undefined; href: string | Reference | undefined };
              },
              index: number,
            ) => (
              <div key={index}>
                <div className={`relative ${
                  lessHeight
                    ? "h-[18rem] md:h-[24rem] 2xl:h-[35rem]"
                    : "h-[18rem] md:h-[34rem] 2xl:h-[45rem]"
                }`}>
                  <picture>
                    <source media="(max-width:699px)" srcSet={`${slide?.banner_desktop_image?.url}`} />
                    <source media="(max-width:640px)" srcSet={`${slide?.banner_desktop_image?.url}`} />
                    <Image
                      // {...image}
                      priority
                      loading="eager"
                      src={slide?.banner_desktop_image?.url}
                      alt={slide?.banner_desktop_image?.description}
                      fill
                      style={{ objectFit: 'cover' }}
                      className="brightness-75"
                      onLoad={() => setLoading(false)}
                      height={500}
                      width={500}
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                  </picture>
                </div>
                {isTabletSize ? (
                  <div className="absolute top-1/2 -translate-y-1/2 pl-128 text-left  xl:left-0 ">
                    {/* <div className={!lessHeight ? "w-1/4" : ""}>
                    <Typography
                      as="h1"
                      className={`text-left text-34 font-semibold text-[#FFF] drop-shadow-sm md:leading-[3rem] ${lessHeight ? 'xl:text-40' : 'xl:text-48'} xl:leading-[4.375rem] ${lessHeight ? '2xl:text-55' : '2xl:text-62'} ${Tiempos.className}`}
                    >
                        {slide?.banner_heading}
                      </Typography>
                    </div> */}
                    <div className={!lessHeight ? "max-w-[14rem] xl:max-w-[20rem] 2xl:max-w-[24rem]" : ""}>
                      <Typography
                        as="h1"
                        className={`text-left text-34 font-semibold text-[#FFF] drop-shadow-sm
                          md:leading-[3.8rem] xl:leading-[4.2rem]
                          ${lessHeight ? 'xl:text-40 2xl:text-55' : 'xl:text-48 2xl:text-62'}
                          ${Tiempos.className}`}
                      >
                        {slide?.banner_heading}
                      </Typography>
                    </div>
                    <div className="w-[60%]">
                      <Typography className={`mt-22 text-left text-18 font-medium leading-8 tracking-wide text-white xl:text-18  2xl:text-20 ${NationalBook.className}`}>
                        {slide?.banner_description}
                      </Typography>
                    </div>
                    {slide?.ctas &&
                      slide?.ctas.map((cta: any) => (
                        <Link link={cta?.button?.href} key={cta?.button?.title}>
                          <Button
                            style={{
                              backgroundColor: cta?.button_background_color?.hex,
                              border: `1px solid ${cta?.button_border_color?.hex}`,
                              color: cta?.button_text_color?.hex,
                            }}
                            className={`mt-22 rounded-none shadow-sm  md:mt-36 md:px-32 md:py-18 lg:mt-32 ${
                              cta?.button_background_color?.hex?.toLowerCase() === '#ffffff'
                                ? 'hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4]'
                                : 'hover:!bg-[#394A54]'
                            }  `}
                          >
                            <Typography as="span" className={`text-12 text-[#090909] md:text-14 lg:text-16 ${NationalSemibold.className}`}>
                              {cta?.button?.title}
                            </Typography>
                          </Button>
                        </Link>
                      ))}
                  </div>
                ) : (
                  <div className="bg-black px-24 pb-63 pt-40">
                    <Typography as="h1" className="text-left text-34 font-semibold leading-tight text-white">
                      {slide?.banner_heading}
                    </Typography>
                    <Typography className="mt-22 text-left text-16 text-white md:text-20 ">
                      {slide?.banner_description}
                    </Typography>
                    {slide?.ctas &&
                      slide?.ctas.map((cta: any) => (
                        <Link link={cta?.button?.href} key={cta?.button?.title}>
                          <Button
                            style={{
                              backgroundColor: cta?.button_background_color?.hex,
                              border: `1px solid ${cta?.button_border_color?.hex}`,
                              color: cta?.button_text_color?.hex,
                            }}
                            className="mt-22 w-full rounded-none bg-white py-18 shadow-sm hover:!bg-[#F4F4F4]"
                          >
                            <Typography as="span" className="text-16 font-medium leading-6 text-[#090909] ">
                              {cta?.button?.title}
                            </Typography>
                          </Button>
                        </Link>
                      ))}
                  </div>
                )}
              </div>
            ),
          )}
        </Slider>
        {/* {image && (
        <div className="relative h-[296px] md:h-[532px] lg:h-[668px]">
          <Image
            {...image}
            priority
            loading="eager"
            alt={title}
            fill
            style={{ objectFit: 'cover', objectPosition: cropFocus }}
            className="brightness-75"
          />
        </div>
      )}
      <div className="absolute left-0 top-1/2 w-full -translate-y-1/2 px-48 text-center">
        <Typography className="text-center text-14 text-white md:text-18">{subtitle}</Typography>
        <Typography as="h1" className="mt-22 text-center text-26 text-white md:mt-32 md:text-36 lg:text-58">
          {title}
        </Typography>
        {ctaLabel && (
          <Link link={ctaReference}>
            <Button className="mt-22 md:mt-36 md:px-48 md:py-12 lg:mt-32">
              <Typography as="span" className="text-12 text-neutral-150 md:text-14 lg:text-16">
                {ctaLabel}
              </Typography>
            </Button>
          </Link>
        )}
      </div> */}
      </div>
    </>
  );
};

export default SectionWithBannerSlider;
